import React, { Fragment } from 'react';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { ICompanyProviders } from 'store/companies/companiesTypes';
import { RootState } from 'store/store';
import {
  pureSearchDocuments,
  requireDocument,
  requireDocumentInFolder,
  updateSurveyReport,
  searchDocuments,
  requireDocumentFn,
  requireDocumentInFolderFn,
  updateSurveyReportFn,
} from 'store/providers/providerSlice';
import {
  IRelatedProviderItem,
  IProviderItems,
  IProviderItemView,
  ItemSearchField,
} from 'store/providers/providerTypes';
import { SearchHolder } from './style';
import Modal from 'components/Modal';
import ItemPicker from 'components/ItemPicker';
import ReportPicker from '../ReportPicker';
import { display } from 'components/ErrorView/ErrorDialog';
import notify from 'components/Notify';
import Select from '../../Select';
import { getTags } from '../../FileManager/ItemsViewer/Survey/SurveyEditor/GeneralQuestion/GeneralQuestionEditor';
import { IOption } from '../../Select/Select';
import Button from '../../Button/Button';
import { appDispatch } from 'store/store';
import {
  IProviderSurveyReport,
  IReportView,
  ISurveyItem,
  ISurveyReportLink,
  ISurveyReports,
  ISurveys,
} from 'store/survey/surveyTypes';
import {
  getReportByIds,
  getReportByIdsFn,
  getReports,
  getReportsFn,
  loadSurvey,
  loadSurveyFn,
} from 'store/survey/surveySlice';
import { IItemPicker } from 'store/entity/types';
import { AxiosPromise } from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import i18n from 'i18next';

interface IDispatchToProps {
  getReportByIds: (reportIds: number[]) => ReturnType<typeof getReportByIdsFn>;
  getReports: (surveyToken: string) => ReturnType<typeof getReportsFn>;
  loadSurvey: (surveyItem: ISurveyItem) => ReturnType<typeof loadSurveyFn>;
  requireSingleDocument: (
    documentId: number
  ) => ReturnType<typeof requireDocumentFn>;
  requireDocumentInFolder: (
    folderId: number,
    providerId: number
  ) => ReturnType<typeof requireDocumentInFolderFn>;
  updateSurveyReport: (
    reportItem: IProviderItemView
  ) => ReturnType<typeof updateSurveyReportFn>;
  pureSearchDocuments: (
    providerId: number,
    query: string,
    folderId?: number
  ) => AxiosPromise<IProviderItemView[]>;
}

interface IStateToProps {
  providerItems: { [key: number]: IProviderItems };
  reports: ISurveyReports;
  surveys: ISurveys['data'];
  reportItem: {
    data: IProviderSurveyReport;
  };
  tagOptions: IOption[];
  searchTermItems: any;
}

interface IOwnProps {
  itemId: number;
  providerId: number;
  onClose: () => void;
  providers: ICompanyProviders;
}

type IComponentProps = IOwnProps & IDispatchToProps & IStateToProps;

interface IComponentStates {
  modalTabs: { id: number; title: string }[];
  loading: boolean;
  providerId?: number;
  saving: boolean;
  selectedProviderItem: IRelatedProviderItem | null;
  selectedReportIds: number[];
  view: 'files' | 'reports';
  selectedItemTags?: IOption;
  selectedReportTags?: IOption;
  windowWidth: number;
}

class ReportExplorerModal extends React.PureComponent<
  IComponentProps,
  IComponentStates
> {
  // modalTabs: Array<{ id: number; title: string }> = Object.values(this.props?.providers || {}).reduce(
  //   (temp, provider) => {
  //     temp.push({ id: provider.id, title: provider.name });
  //     return temp;
  //   },
  //   [] as Array<{ id: number; title: string }>
  // );

  state: IComponentStates = {
    modalTabs: [],
    loading: false,
    providerId: undefined,
    saving: false,
    selectedProviderItem: null,
    selectedReportIds: [],
    view: 'files',
    selectedItemTags: undefined,
    selectedReportTags: undefined,
    windowWidth: window.innerWidth,
  };

  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }

  isRootFolderLoaded = () => {
    const { providerItems, providers } = this.props;
    return (
      this.state.providerId &&
      providerItems[this.state.providerId].folders[
        providers[this.state.providerId].rootDocumentId
      ].state === 'loaded'
    );
  };

  handleRequireDocumentsInFolder = (requiredFolderId: number) => {
    return this.props.requireDocumentInFolder(
      requiredFolderId,
      this.state.providerId!
    );
  };

  handleRequireFolderAndItems = (requiredFolderId: number) => {
    const dadItemId =
      this.props.providerItems[this.state.providerId!].items[requiredFolderId];
    if (dadItemId) {
      return Promise.resolve();
    } else {
      return Promise.all([
        this.props.requireSingleDocument(requiredFolderId),
        this.handleRequireDocumentsInFolder(requiredFolderId),
      ]);
    }
  };

  handleSelectATab = (providerId: number | string) => {
    this.setState({ providerId: providerId as number, loading: true });
  };

  onChangeProviderItem = (providerItem: IRelatedProviderItem) => {
    if (providerItem) {
      const { type } = providerItem;
      if (type === 'surveyReport' || type === 'survey') {
        this.setState(
          { selectedProviderItem: providerItem },
          this.handleChangeStep
        );
      }
    } else {
      this.setState({ selectedProviderItem: providerItem });
    }
  };

  onChangeReportItem = (reportId: number[]) => {
    this.setState({ selectedReportIds: reportId });
  };

  handleChangeStep = () => {
    this.setState((prevState) => ({
      view: prevState.view === 'reports' ? 'files' : 'reports',
    }));
    if (this.state.selectedProviderItem && this.state.view === 'files') {
      this.setState({ loading: true });
      const item =
        this.props.providerItems[this.state.selectedProviderItem.providerId]
          .items[this.state.selectedProviderItem.id].data;
      if (item.type === 'survey') {
        const surveyItem = item;
        this.props.loadSurvey(surveyItem as ISurveyItem).then(() => {
          const surveyToken =
            this.props.surveys[item.surveyId!].data.surveyToken;
          this.props.getReports(surveyToken!).then(() => {
            this.setState({ loading: false });
          });
        });
      } else {
        const reportIds =
          this.props.providerItems[this.state.providerId!].items[
            this.state.selectedProviderItem.id
          ].data['reportIds'];
        if (reportIds)
          this.props.getReportByIds(reportIds).then(() => {
            this.setState({ loading: false });
          });
        else {
          this.setState({ loading: false });
        }
      }
    } else if (this.state.view === 'reports') {
      this.setState({ selectedReportIds: [], selectedProviderItem: null });
    }
  };

  handleSaveReport = () => {
    const { reportItem: reportItemProp, reports } = this.props;
    if (/*this.state.selectedProviderItem && */ this.state.selectedReportIds) {
      const selectedItem = this.state.selectedProviderItem
        ? this.props.providerItems[this.state.selectedProviderItem!.providerId!]
            .items[this.state.selectedProviderItem!.id!]
        : null;

      if (reportItemProp) {
        this.setState({ saving: true });
        const reportItem = cloneDeep(reportItemProp);
        if (!selectedItem) {
          const reportLinks: ISurveyReportLink[] =
            reportItem.data.surveyReportLinks || [];
          const newItems: ISurveyReportLink[] =
            this.state.selectedReportIds.map((it: number) => {
              const reportSurveyId = Object.values(reports.data).find(
                (report: IReportView) => report.id === it
              )!.surveyId;
              const item = Object.values(
                this.props.providerItems[this.props.providerId].items
              ).find(
                (it: any) =>
                  reportSurveyId && it.data.surveyId === reportSurveyId
              )!;
              return {
                reportId: it,
                surveyReportToken: item.data.reportToken!,
                itemId: item.data.id,
              };
            });
          reportLinks.push(...newItems);
          reportItem.data.surveyReportLinks = reportLinks;
        } else if (selectedItem.data.type === 'surveyReport') {
          const currentIds = reportItem.data.reportIds || [];
          const ids = new Set([...currentIds, ...this.state.selectedReportIds]);
          reportItem.data.reportIds = Array.from(ids);
        } else if (selectedItem.data.type === 'survey') {
          const reportLinks: ISurveyReportLink[] =
            reportItem.data.surveyReportLinks || [];
          const newItems: ISurveyReportLink[] =
            this.state.selectedReportIds.map((it: number) => ({
              reportId: it,
              surveyReportToken: selectedItem.data.reportToken!,
              itemId: this.state.selectedProviderItem!.id,
            }));
          reportLinks.push(...newItems);
          reportItem.data.surveyReportLinks = reportLinks;
        }

        this.props
          .updateSurveyReport(reportItem.data)
          .then(() => {
            this.setState({ saving: false, selectedReportIds: [] });
            notify(i18n.t('reportSuccessfullyAdded', { ns: 'survey' }));
          })
          .catch((err) => {
            this.setState({ saving: false });
            display(err);
          });
      }
    }
  };

  searchReport = () => {
    const { providerId, getReports } = this.props;
    const query = this.state.selectedItemTags?.label;
    if (!query) return;
    const searchKey = `tags_${this.state.selectedItemTags?.value}`;
    this.setState({ loading: true, view: 'reports' });
    appDispatch(
      searchDocuments({
        searchTerm: searchKey,
        query,
        providerId,
        searchFields: ['exactTag'] as ItemSearchField[],
        start: 0,
        count: 1000,
        folderId: undefined,
      })
    ).then((e: ISurveyItem[]) => {
      if (e && e.length) {
        const promises = [];
        promises.push(
          ...e.map((item: ISurveyItem) => {
            const token = item.reportToken!;
            return getReports(token);
          })
        );
        Promise.allSettled(promises)
          .then(() => {
            this.setState({
              loading: false,
              view: 'reports',
              selectedProviderItem: null,
            });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      } else {
        this.setState({ loading: false });
      }
    });
  };

  componentDidMount() {
    const modalTabs = Object.values(this.props?.providers || {}).reduce(
      (temp, provider) => {
        temp.push({ id: provider.id, title: provider.name });
        return temp;
      },
      [] as Array<{ id: number; title: string }>
    );
    this.setState(
      {
        modalTabs,
        providerId: modalTabs[0].id,
      },
      () => {
        if (!this.isRootFolderLoaded()) {
          this.handleRequireDocumentsInFolder(
            this.props.providers[this.props.providerId].rootDocumentId
          );
        }
      }
    );

    window.addEventListener('resize', () => {
      this.setState({ windowWidth: window.innerWidth });
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const {
      onClose,
      providerItems,
      providers,
      reports,
      reportItem,
      tagOptions,
    } = this.props;
    const {
      selectedProviderItem,
      loading,
      providerId,
      selectedReportTags,
      selectedItemTags,
    } = this.state;

    const isRootFolderLoaded = this.isRootFolderLoaded();

    const reportItemObj = reportItem.data;
    const currentSelected = [
      ...(reportItemObj.reportIds || []),
      ...(reportItemObj.surveyReportLinks?.map(
        (it: ISurveyReportLink) => it.reportId
      ) || []),
    ];

    let selectedItem: IItemPicker | null = null;
    let relatedProviderItem: any;
    if (
      selectedProviderItem &&
      isRootFolderLoaded &&
      selectedProviderItem.providerId === providerId
    ) {
      /*
        third condition check that item belongs to current provider or not on switch tab
      */
      relatedProviderItem =
        providerItems[providerId].items[selectedProviderItem.id].data;
      if (relatedProviderItem)
        selectedItem = {
          id: relatedProviderItem.id,
          name: relatedProviderItem.name,
          dadId: relatedProviderItem.dadId,
          type: 'surveyReport',
        };
    }
    let reportIds: any;
    if (relatedProviderItem) {
      if (relatedProviderItem.type === 'survey') {
        reportIds = Object.keys(this.props.reports.data)
          .filter(
            (report) =>
              this.props.reports.data[report].surveyId ===
              relatedProviderItem.surveyId
          )
          .map((it) => Number(it));
      } else {
        reportIds = relatedProviderItem.reportIds;
      }
    } else {
      reportIds = [];
      const surveyIds = new Set<number>();
      if (selectedItemTags && this.state.view === 'reports' && !loading) {
        Object.values(providerItems[providerId!].items).forEach((item: any) => {
          if (
            item.data.type === 'survey' &&
            item.data.tags.find((it: any) => it.id === selectedItemTags.value)
          ) {
            surveyIds.add(item.data.surveyId);
          }
        });
        Object.values(this.props.reports.data)
          .filter(
            (report: IReportView) =>
              report.surveyId &&
              surveyIds.has(report.surveyId) &&
              (!selectedReportTags ||
                report.tags.includes(selectedReportTags!.label))
          )
          .forEach((report) => {
            reportIds.push(report.id);
          });
      }
    }

    return (
      this.state.modalTabs.length > 0 &&
      providerId && (
        <Modal
          width={this.state.windowWidth < 600 ? '90%' : '50%'}
          tabs={this.state.modalTabs}
          title={i18n.t('addReport', { ns: 'taskManager' }) as string}
          onClose={onClose}
          isActive={true}
          selectedTab={providerId}
          onSelectATab={this.handleSelectATab}
        >
          <SearchHolder>
            <Select
              multiChoice={false}
              options={tagOptions}
              values={selectedItemTags ? [selectedItemTags] : []}
              onChangeValues={(values) => {
                this.setState({ selectedItemTags: values[0] });
              }}
              label={i18n.t('itemTags', { ns: 'taskManager' }) as string}
              placeholder={i18n.t('itemTags', { ns: 'taskManager' })}
            />
            <Select
              multiChoice={false}
              options={tagOptions}
              values={selectedReportTags ? [selectedReportTags] : []}
              onChangeValues={(values) => {
                this.setState({ selectedReportTags: values[0] });
              }}
              label={i18n.t('reportTags', { ns: 'taskManager' }) as string}
              placeholder={i18n.t('reportTags', { ns: 'taskManager' })}
            />
            <Button
              loading={loading}
              onClick={this.searchReport}
              disabled={!selectedItemTags}
              style={{ marginBottom: '10px' }}
            >
              {i18n.t('search', { ns: 'taskManager' }) as string}
            </Button>
          </SearchHolder>
          <Fragment>
            {isRootFolderLoaded ? (
              <div
                style={{
                  height: 'calc(100% - 110px)',
                  display:
                    this.state.view === 'files' && !loading ? '' : 'none',
                }}
              >
                <ItemPicker
                  providerId={providerId}
                  saveTitle={i18n.t('nextStep', { ns: 'taskManager' })}
                  onSaveItem={this.onChangeProviderItem}
                  providerItems={providerItems[providerId].items}
                  rootFolder={{
                    id: providers[providerId].rootDocumentId,
                    name: i18n.t('rootFolderName', {
                      ns: 'taskManager',
                      folderName: providers[providerId].name,
                    }),
                    dadId: -1,
                    type: 'folder',
                  }}
                  selectedProviderItem={selectedItem}
                  onRequireFolderAndItems={this.handleRequireFolderAndItems}
                  onRequireDocumentsInFolder={
                    this.handleRequireDocumentsInFolder
                  }
                  onSearchForDocuments={(text, dadFolderId) =>
                    this.props.pureSearchDocuments(
                      Number(providerId),
                      text,
                      dadFolderId
                    )
                  }
                />
              </div>
            ) : (
              <p style={{ alignSelf: 'center', textAlign: 'center' }}>
                {i18n.t('loading', { ns: 'taskManager' }) as string}
              </p>
            )}
          </Fragment>

          {this.state.view !== 'files' && (
            <Fragment>
              {loading ? (
                <p style={{ alignSelf: 'center', textAlign: 'center' }}>
                  {i18n.t('loading', { ns: 'taskManager' }) as string}
                </p>
              ) : (
                <ReportPicker
                  onChangeView={this.handleChangeStep}
                  onSaveReport={this.handleSaveReport}
                  saving={this.state.saving}
                  showBackButton={this.state.view === 'reports'}
                  onSelectReport={this.onChangeReportItem}
                  reports={reports}
                  reportIds={reportIds}
                  currentSelected={currentSelected}
                  selectedReport={this.state.selectedReportIds}
                />
              )}
            </Fragment>
          )}
        </Modal>
      )
    );
  }
}

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => {
  return {
    requireSingleDocument: (documentId: number) =>
      appDispatch(requireDocument({ documentId })),
    requireDocumentInFolder: (folderId: number, providerId: number) =>
      appDispatch(requireDocumentInFolder({ folderId, providerId })),
    getReportByIds: (reportIds: number[]) =>
      appDispatch(getReportByIds({ reportIds })),
    updateSurveyReport: (reportItem: IProviderItemView) =>
      appDispatch(updateSurveyReport({ item: reportItem })),
    getReports: (surveyToken: string) =>
      appDispatch(getReports({ surveyToken })),
    loadSurvey: (surveyItem: ISurveyItem) =>
      appDispatch(loadSurvey({ providerSurveyItemData: surveyItem })),
    pureSearchDocuments: (
      providerId: number,
      query: string,
      folderId?: number
    ) =>
      appDispatch(
        pureSearchDocuments({
          query,
          providerId,
          start: 0,
          count: 100,
          folderId,
        })
      ),
    appDispatch,
  };
};

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const providerItems = state.providers.items;
  const reports = state.survey.reports;
  const surveys = state.survey.data;
  const reportItem = providerItems[props.providerId].items[props.itemId] as {
    data: IProviderSurveyReport;
  };
  const allTags = state.providers.tags[props.providerId]!.data;
  const tagOptions = getTags(allTags, true);
  const searchTermItems = state.providers.items[props.providerId].search;

  return {
    providerItems,
    reports,
    surveys,
    reportItem,
    tagOptions,
    searchTermItems,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportExplorerModal);
